export enum MetadataTypes {
  author = "AUTHOR",
  organization = "ORGANIZATION_lead",
}
